import axios from "axios";
import { toast } from "react-toastify";
const url = process.env.REACT_APP_BASE_URL;
const version = "v1";
const baseURL = `${url}/api/${version}`;
const isDevelopment = process.env.NODE_ENV === "development";
let host = `${window.location.protocol}//${window.location.host}`;

//for export as functionality
const endPointExport_as = isDevelopment
  ? `${baseURL}/export_as/`
  : `${host}/api/${version}/export_as/`;
const baseProject_payment = isDevelopment
  ? `${baseURL}/project_payment/`
  : `${host}/api/${version}/project_payment/`;
const baseSupplier_estimates = isDevelopment
  ? `${baseURL}/supplier_estimates/`
  : `${host}/api/${version}/supplier_estimates/`;
const baseProject = isDevelopment
  ? `${baseURL}/project/`
  : `${host}/api/${version}/project/`;
const baseSupplier_estimatesWithQuery = isDevelopment
  ? `${baseURL}/supplier_estimates/?active=True`
  : `${host}/api/${version}/supplier_estimates/?active=True`;

// URLs
const endPointLogout = "/logout/";
const profileURL = "/login/";
const usersProfileURL = "/profile/";
const userCreateURL = "/user/create/";
const endPointProfile = "/profile/";
const endPointUserForgot_password = "/forgot_password/";
const endPointCheck_validity = "/check_validity/";
const endPointReset_password = "/reset_password/";
const endPointChange_password = "/change_password/";
const endPointcustomer = "/customer/";
const endPointProject = "/project/";
const endPointPendingAllocation = "/project/pending_allocation/";
const endPointPaymentsDashboard = "/payments_dashboard/";
const endPointProjectSearch = "/project/search/";
const endPointTask = "/task/";
const endPointSubcontractor_type = "/supplier_type/";
const endPointSubcontractor = "/suppliers/";
const endPointSubcontractor_estimate = "/supplier_estimates/";
const endPointVendor_types = "/vendor_types/";
const endPointVendors = "/vendors/";
const endPointVendor_estimates = "/vendor_estimates/";
const endpointNavigator = "/navigation_constructor/";
const endPointProject_signoff = "/project_signoff/";
const endPointSignoff = "/signoff/";
const endPointTask_history = "/task_history/";
const endPointDrivem = "/drivem/";
const endPointCategories = "/categories/";
const endPointSubCategories = "/subcategories/";
const endPointSupplier_estimate_pay_history = "/supplier_estimate_pay_history/";
const endPointPayments = "/payments/";
const endPointProject_payment = "/project_payment/";
const endPointQuestion = "/question/";
const endPointQueries = "/queries/";
const endPointProject_queries = "/project_queries/";
const endPointChecklist = "/checklist/";
const endPointLabour_payment_report = "/labour_payment_report/";
const endPointCashbook_report = "/cashbook_report/";
const endPointProject_orders = "/project_orders/";
const endPointOrder_items_history = "/order_items_history/";
const endPointOrder_item_upload = "/order_item_upload/";
const endPointTeam_members = "/team_members/";
const endPointFactory_production = "/factory_production/";
const endPointFactory_capacity = "/factory_production/capacity/";
const endPointFactory_meta = "/factory_production/meta/";
const endPointFactory_project_search = "/factory_production/project_search/";
const endPointFactory_export = "/factory_production/export/";
const endPointFactory_daily_totals = "/factory_production/daily_totals/";
const endPointAdmin_reset_password = "/admin_reset_password/";

//for procurement request
const endPointOrders = "/orders/";

//for Sub-contractor Quotations
const endPointOrder_items = "/order_items/";
const endPointSupplier_quotation = "/supplier_quotation/";

// create axios client
const client = axios.create({
  baseURL: baseURL,
  withCredentials: false,
});

const setToken = () => {
  const token = localStorage.getItem("token");
  client.defaults.headers.common["Authorization"] = token;
};

const unSetToken = () => {
  delete client.defaults.headers.common["Authorization"];
};

const request = async ({ method = "GET", url, data, requireToken = false }) => {
  try {
    if (requireToken === true) {
      setToken();
    } else {
      unSetToken();
    }
    if (method === "GET") {
      const response = await client.get(url, data);
      return response.data;
    } else if (method === "POST") {
      const response = await client.post(url, data);
      return response.data;
    } else if (method === "DELETE") {
      const response = await client.delete(url, data);
      return response.data;
    } else if (method === "PATCH") {
      const response = await client.patch(url, data);
      return response.data;
    }
  } catch (error) {
    if (url !== profileURL && error.response.status === 401) {
      window.location.href = "/";
      localStorage.clear();
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.detail
    ) {
      throw new Error(error.response.data.detail);
    }
    throw new Error(error.message);
  }
};

const postLogout = (data) => {
  return request({
    method: "POST",
    url: endPointLogout,
    data: data,
    requireToken: true,
  });
};
const postUserLogin = async (data) => {
  return await request({
    method: "POST",
    url: profileURL,
    data: data,
    requireToken: false,
  });
};

const getUsersProfile = async ({ active = "True" }) => {
  return request({
    method: "GET",
    url: `${usersProfileURL}?active=${active ?? "True"}`,
    requireToken: true,
  });
};
const getProfile = (data) => {
  return request({
    method: "GET",
    url: endPointProfile,
    data: { params: data },
    requireToken: true,
  });
};
const updateProfile = async (data) => {
  return request({
    method: "POST",
    url: usersProfileURL,
    data: data,
    requireToken: true,
  });
};

const createUpdateUserProfile = async (data, isUpdateAPI) => {
  const params = {
    username: data.username,
    first_name: data.firstname,
    last_name: data.lastname,
    email: data.username,
    employee_id: data.employeeId,
  };
  if (isUpdateAPI) {
    params.id = data.userId;
  }
  if (!isUpdateAPI) {
    params.password = data.password;
  }
  const user = await request({
    method: "POST",
    url: userCreateURL,
    data: params,
    requireToken: true,
  });

  let createProfileData = {
    role: data.role,
    user: user?.id,
    mobile_no: data.mobile,
    employee_id: data.employeeId,
  };
  if (isUpdateAPI) {
    createProfileData.id = data.profileId;
    createProfileData.user = data.userId;
  }

  const profile = await request({
    method: "POST",
    url: usersProfileURL,
    data: createProfileData,
    requireToken: true,
  });
  return profile;
};

const deleteUsersProfile = async (payload) => {
  return request({
    method: "POST",
    url: usersProfileURL,
    data: payload,
    requireToken: true,
  });
};

const forgetPassword = (payload) => {
  return request({
    method: "POST",
    url: endPointUserForgot_password,
    data: payload,
    requireToken: false,
  });
};
const postCheck_validity = (payload) => {
  return request({
    method: "POST",
    url: endPointCheck_validity,
    data: payload,
    requireToken: false,
  });
};
const postReset_password = (payload) => {
  return request({
    method: "POST",
    url: endPointReset_password,
    data: payload,
    requireToken: false,
  });
};
const getCustomer = (payload) => {
  return request({
    method: "GET",
    url: endPointcustomer,
    data: payload,
    requireToken: true,
  });
};
const postChange_password = (payload) => {
  return request({
    method: "POST",
    url: endPointChange_password,
    data: payload,
    requireToken: true,
  });
};
const getProject = (data) => {
  return request({
    method: "GET",
    url: endPointProject,
    data: { params: data },
    requireToken: true,
  });
};
const postProject = (payload) => {
  return request({
    method: "POST",
    url: endPointProject,
    data: payload,
    requireToken: true,
  });
};
const fetchPendingAllocations = () => {
  return request({
    method: "GET",
    url: endPointPendingAllocation,
    requireToken: true,
  });
};
const allocateProjectTeam = (projectId, userIds) => {
  return request({
    method: "POST",
    url: `/project/${projectId}/allocate/`,
    data: { user_ids: userIds },
    requireToken: true,
  });
};

// F10: Payments dashboard
const fetchPaymentsDashboard = (params) => {
  return request({
    method: "GET",
    url: endPointPaymentsDashboard,
    data: { params: params || {} },
    requireToken: true,
  });
};

// F10: Mark a payment task as collected (payments@ or admin only on the backend)
const markPaymentCollected = (projectId, taskId) => {
  return request({
    method: "POST",
    url: `/project/${projectId}/payment_task/${taskId}/mark_collected/`,
    requireToken: true,
  });
};

// F8: Create a manual payment task (civil_team or civil_head only on the backend)
const createManualPaymentTask = (projectId, payload) => {
  return request({
    method: "POST",
    url: `/project/${projectId}/manual_payment_task/`,
    data: payload,
    requireToken: true,
  });
};

// F8: Soft-delete a manual payment task (only when collected_amount=0)
const deleteManualPaymentTask = (projectId, taskId) => {
  return request({
    method: "DELETE",
    url: `/project/${projectId}/manual_payment_task/${taskId}/`,
    requireToken: true,
  });
};

// F8/F3: Edit a payment task (role-aware on backend)
const editPaymentTask = (projectId, taskId, payload) => {
  return request({
    method: "PATCH",
    url: `/project/${projectId}/payment_task/${taskId}/edit/`,
    data: payload,
    requireToken: true,
  });
};


// ===== F4 Reports — endpoints =====
const endPointReportSiteMarking         = "/reports/site_marking/";
const endPointReport3D                  = "/reports/3d_discussion/";
const endPointReportQuotation           = "/reports/quotation_discussion/";
const endPointReport2DMaterial          = "/reports/2d_material/";
const endPointReportHandover            = "/reports/handover_pending/";
const endPointReportCutlistPending      = "/reports/exec_cutlist_pending/";
const endPointReportCutlistDoneNoPlan   = "/reports/exec_cutlist_done_no_plan/";
const endPointReportFactoryProduction   = "/reports/exec_factory_production/";
const endPointReportDispatchPending     = "/reports/exec_dispatch_pending/";
const endPointReportCarcass             = "/reports/exec_carcass/";
const endPointReportAccessories         = "/reports/exec_accessories/";
const endPointReportFinalFitting        = "/reports/exec_final_fitting/";
const endPointReportSiteMaskingPending  = "/reports/site_masking_pending/";
const endPointReportPlanVsActual        = "/reports/plan_vs_actual/";
const endPointReportProjectBreakdown    = "/reports/project_breakdown/";
const endPointReportTimeline            = "/reports/timeline/";

const fetchReportSiteMarking       = () => request({ method: "GET", url: endPointReportSiteMarking,       requireToken: true });
const fetchReport3DDiscussion      = () => request({ method: "GET", url: endPointReport3D,                requireToken: true });
const fetchReportQuotation         = () => request({ method: "GET", url: endPointReportQuotation,         requireToken: true });
const fetchReport2DMaterial        = () => request({ method: "GET", url: endPointReport2DMaterial,        requireToken: true });
const fetchReportHandoverPending   = () => request({ method: "GET", url: endPointReportHandover,          requireToken: true });
const fetchReportCutlistPending    = () => request({ method: "GET", url: endPointReportCutlistPending,    requireToken: true });
const fetchReportCutlistDoneNoPlan = () => request({ method: "GET", url: endPointReportCutlistDoneNoPlan, requireToken: true });
const fetchReportFactoryProduction = () => request({ method: "GET", url: endPointReportFactoryProduction, requireToken: true });
const fetchReportDispatchPending   = () => request({ method: "GET", url: endPointReportDispatchPending,   requireToken: true });
const fetchReportCarcass           = (centre) => request({ method: "GET", url: endPointReportCarcass,           data: { params: centre ? { centre } : {} }, requireToken: true });
const fetchReportAccessories       = (centre) => request({ method: "GET", url: endPointReportAccessories,       data: { params: centre ? { centre } : {} }, requireToken: true });
const fetchReportFinalFitting      = (centre) => request({ method: "GET", url: endPointReportFinalFitting,      data: { params: centre ? { centre } : {} }, requireToken: true });
const fetchReportSiteMaskingPending = () => request({ method: "GET", url: endPointReportSiteMaskingPending, requireToken: true });
const fetchReportPlanVsActual = (centre, project) => request({ method: "GET", url: endPointReportPlanVsActual, data: { params: { centre: centre || undefined, project: project || undefined } }, requireToken: true });
const fetchReportProjectBreakdown  = (projectId) => request({
  method: "GET", url: endPointReportProjectBreakdown,
  data: { params: { project_id: projectId } }, requireToken: true,
});
const fetchReportTimeline = (params) => request({
  method: "GET", url: endPointReportTimeline,
  data: { params: params || {} }, requireToken: true,
});


// Project typeahead search for F8 modal
const searchProjects = (q) => {
  return request({
    method: "GET",
    url: endPointProjectSearch,
    data: { params: { q: q } },
    requireToken: true,
  });
};


const getTask = (data) => {
  return request({
    method: "GET",
    url: endPointTask,
    data: { params: data },
    requireToken: true,
  });
};
const postTask = (payload) => {
  return request({
    method: "POST",
    url: endPointTask,
    data: payload,
    requireToken: true,
  });
};
const getSubcontractor = (data) => {
  return request({
    method: "GET",
    url: endPointSubcontractor,
    data: { params: data },
    requireToken: true,
  });
};
const postSubcontractor = (payload) => {
  return request({
    method: "POST",
    url: endPointSubcontractor,
    data: payload,
    requireToken: true,
  });
};
const getSubcontractor_type = (data) => {
  return request({
    method: "GET",
    url: endPointSubcontractor_type,
    data: { params: data },
    requireToken: true,
  });
};
const postSubcontractor_type = (payload) => {
  return request({
    method: "POST",
    url: endPointSubcontractor_type,
    data: payload,
    requireToken: true,
  });
};
const getSubcontractor_estimate = (data) => {
  return request({
    method: "GET",
    url: endPointSubcontractor_estimate,
    data: { params: data },
    requireToken: true,
  });
};
const postSubcontractor_estimate = (payload) => {
  return request({
    method: "POST",
    url: endPointSubcontractor_estimate,
    data: payload,
    requireToken: true,
  });
};
const getVendor_types = (data) => {
  return request({
    method: "GET",
    url: endPointVendor_types,
    data: { params: data },
    requireToken: true,
  });
};
const postVendor_types = (payload) => {
  return request({
    method: "POST",
    url: endPointVendor_types,
    data: payload,
    requireToken: true,
  });
};
const getVendors = (data) => {
  return request({
    method: "GET",
    url: endPointVendors,
    data: { params: data },
    requireToken: true,
  });
};
const postVendors = (payload) => {
  return request({
    method: "POST",
    url: endPointVendors,
    data: payload,
    requireToken: true,
  });
};
const getVendor_estimates = (data) => {
  return request({
    method: "GET",
    url: endPointVendor_estimates,
    data: { params: data },
    requireToken: true,
  });
};
const postVendor_estimates = (payload) => {
  return request({
    method: "POST",
    url: endPointVendor_estimates,
    data: payload,
    requireToken: true,
  });
};

const getSideBar = async () => {
  const data = await request({
    method: "GET",
    url: endpointNavigator,
    data: { role__short_name: localStorage.getItem("role") },
    requireToken: true,
  });

  return data;
};
const getProject_signoff = (data) => {
  return request({
    method: "GET",
    url: endPointProject_signoff,
    data: { params: data },
    requireToken: true,
  });
};
const postProject_signoff = (payload) => {
  return request({
    method: "POST",
    url: endPointProject_signoff,
    data: payload,
    requireToken: true,
  });
};
const getSignoff = (data) => {
  return request({
    method: "GET",
    url: endPointSignoff,
    data: { params: data },
    requireToken: true,
  });
};
const postSignoff = (payload) => {
  return request({
    method: "POST",
    url: endPointSignoff,
    data: payload,
    requireToken: true,
  });
};
const getTask_history = (data) => {
  return request({
    method: "GET",
    url: endPointTask_history,
    data: { params: data },
    requireToken: true,
  });
};
const postTask_history = (payload) => {
  return request({
    method: "POST",
    url: endPointTask_history,
    data: payload,
    requireToken: true,
  });
};
const getDrivem = (data) => {
  return request({
    method: "GET",
    url: endPointDrivem,
    data: { params: data },
    requireToken: true,
  });
};
const postDrivem = (payload) => {
  return request({
    method: "POST",
    url: endPointDrivem,
    data: payload,
    requireToken: true,
  });
};

const getCategories = (data) => {
  return request({
    method: "GET",
    url: endPointCategories,
    data: { params: data },
    requireToken: true,
  });
};
const getSubCategories = (data) => {
  return request({
    method: "GET",
    url: endPointSubCategories,
    data: { params: data },
    requireToken: true,
  });
};
const getSupplier_estimate_pay_history = (data) => {
  return request({
    method: "GET",
    url: endPointSupplier_estimate_pay_history,
    data: { params: data },
    requireToken: true,
  });
};
const postSupplier_estimate_pay_history = (payload) => {
  return request({
    method: "POST",
    url: endPointSupplier_estimate_pay_history,
    data: payload,
    requireToken: true,
  });
};
const getPayments = (data) => {
  return request({
    method: "GET",
    url: endPointPayments,
    data: { params: data },
    requireToken: true,
  });
};
const postPayments = (payload) => {
  return request({
    method: "POST",
    url: endPointPayments,
    data: payload,
    requireToken: true,
  });
};
const getProject_payment = (data) => {
  return request({
    method: "GET",
    url: endPointProject_payment,
    data: { params: data },
    requireToken: true,
  });
};
const postProject_payment = (payload) => {
  return request({
    method: "POST",
    url: endPointProject_payment,
    data: payload,
    requireToken: true,
  });
};
const getQuestion = (data) => {
  return request({
    method: "GET",
    url: endPointQuestion,
    data: { params: data },
    requireToken: true,
  });
};
const postQuestion = (payload) => {
  return request({
    method: "POST",
    url: endPointQuestion,
    data: payload,
    requireToken: true,
  });
};
const getQueries = (data) => {
  return request({
    method: "GET",
    url: endPointQueries,
    data: { params: data },
    requireToken: true,
  });
};
const postQueries = (payload) => {
  return request({
    method: "POST",
    url: endPointQueries,
    data: payload,
    requireToken: true,
  });
};
const getProject_queries = (data) => {
  return request({
    method: "GET",
    url: endPointProject_queries,
    data: { params: data },
    requireToken: true,
  });
};
const postProject_queries = (payload) => {
  return request({
    method: "POST",
    url: endPointProject_queries,
    data: payload,
    requireToken: true,
  });
};
const getChecklist = (data) => {
  return request({
    method: "GET",
    url: endPointChecklist,
    data: { params: data },
    requireToken: true,
  });
};
const postChecklist = (payload) => {
  return request({
    method: "POST",
    url: endPointChecklist,
    data: payload,
    requireToken: true,
  });
};
const getLabour_payment_report = (payload) => {
  return request({
    method: "GET",
    url: endPointLabour_payment_report,
    data: payload,
    requireToken: true,
  });
};
const getCashbook_report = (data) => {
  return request({
    method: "GET",
    url: endPointCashbook_report,
    data: { params: data },
    requireToken: true,
  });
};

const getProject_orders = (data) => {
  return request({
    method: "GET",
    url: endPointProject_orders,
    data: { params: data },
    requireToken: true,
  });
};
const postProject_orders = (payload) => {
  return request({
    method: "POST",
    url: endPointProject_orders,
    data: payload,
    requireToken: true,
  });
};

const getOrders = (data) => {
  return request({
    method: "GET",
    url: endPointOrders,
    data: { params: data },
    requireToken: true,
  });
};
const postOrders = (payload) => {
  return request({
    method: "POST",
    url: endPointOrders,
    data: payload,
    requireToken: true,
  });
};

const getPointOrder_items = (data) => {
  return request({
    method: "GET",
    url: endPointOrder_items,
    data: { params: data },
    requireToken: true,
  });
};
const postOrder_items = (payload) => {
  return request({
    method: "POST",
    url: endPointOrder_items,
    data: payload,
    requireToken: true,
  });
};
const getOrder_items_history = (data) => {
  return request({
    method: "GET",
    url: endPointOrder_items_history,
    data: { params: data },
    requireToken: true,
  });
};
const postOrder_items_history = (payload) => {
  return request({
    method: "POST",
    url: endPointOrder_items_history,
    data: payload,
    requireToken: true,
  });
};
const getSupplier_quotation = (data) => {
  return request({
    method: "GET",
    url: endPointSupplier_quotation,
    data: { params: data },
    requireToken: true,
  });
};
const postSupplier_quotation = (payload) => {
  return request({
    method: "POST",
    url: endPointSupplier_quotation,
    data: payload,
    requireToken: true,
  });
};

const getTeamMembers = (data) => {
  return request({
    method: "GET",
    url: endPointTeam_members,
    data: { params: data },
    requireToken: true,
  });
};

const adminResetPassword = (data) => {
  return request({
    method: "POST",
    url: endPointAdmin_reset_password,
    data: data,
    requireToken: true,
  });
};

const getFactoryProductionMeta = () => {
  return request({
    method: "GET",
    url: endPointFactory_meta,
    requireToken: true,
  });
};

const getStageCapacities = () => {
  return request({
    method: "GET",
    url: endPointFactory_capacity,
    requireToken: true,
  });
};

const upsertStageCapacity = (data) => {
  return request({
    method: "POST",
    url: endPointFactory_capacity,
    data: data,
    requireToken: true,
  });
};

const updateStageCapacity = (id, data) => {
  return request({
    method: "PATCH",
    url: endPointFactory_capacity + id + "/",
    data: data,
    requireToken: true,
  });
};

const getProductionEntries = (data) => {
  return request({
    method: "GET",
    url: endPointFactory_production,
    data: { params: data },
    requireToken: true,
  });
};

const createProductionEntry = (data) => {
  return request({
    method: "POST",
    url: endPointFactory_production,
    data: data,
    requireToken: true,
  });
};

const updateProductionEntry = (id, data) => {
  return request({
    method: "PATCH",
    url: endPointFactory_production + id + "/",
    data: data,
    requireToken: true,
  });
};

const updatePlan = (id, data) => {
  // data: { date: "YYYY-MM-DD", sheets: N }
  return request({
    method: "POST",
    url: endPointFactory_production + id + "/update_plan/",
    data: data,
    requireToken: true,
  });
};

const deletePlan = (id) => {
  return request({
    method: "POST",
    url: endPointFactory_production + id + "/delete_plan/",
    data: {},
    requireToken: true,
  });
};

const deleteProductionEntry = (id) => {
  return request({
    method: "DELETE",
    url: endPointFactory_production + id + "/",
    requireToken: true,
  });
};

const markProductionEntryDone = (id, data) => {
  return request({
    method: "POST",
    url: endPointFactory_production + id + "/mark_done/",
    data: data,
    requireToken: true,
  });
};

const searchFactoryProjects = (q) => {
  return request({
    method: "GET",
    url: endPointFactory_project_search,
    data: { params: { q: q } },
    requireToken: true,
  });
};

const getFactoryDailyTotals = (data) => {
  return request({
    method: "GET",
    url: endPointFactory_daily_totals,
    data: { params: data },
    requireToken: true,
  });
};

const buildFactoryExportUrl = (dateFrom, dateTo) => {
  return baseURL + endPointFactory_export + "?date_from=" + encodeURIComponent(dateFrom) + "&date_to=" + encodeURIComponent(dateTo);
};
const postOrder_item_upload = (payload) => {
  return request({
    method: "POST",
    url: endPointOrder_item_upload,
    data: payload,
    requireToken: true,
  });
};

// ---------------------------------------------------------------------------
// Purchase
// ---------------------------------------------------------------------------
const endPointPurchase_options = "/purchase/options/";
const endPointPurchase_project_search = "/purchase/project_search/";
const endPointPurchase_requests = "/purchase/requests/";

const getPurchaseOptions = () =>
  request({ method: "GET", url: endPointPurchase_options, requireToken: true });
const searchPurchaseProjects = (q) =>
  request({ method: "GET", url: endPointPurchase_project_search, data: { params: { q: q } }, requireToken: true });
const getPurchaseRequests = (params) =>
  request({ method: "GET", url: endPointPurchase_requests, data: { params: params }, requireToken: true });
const getPurchaseRequest = (id) =>
  request({ method: "GET", url: endPointPurchase_requests + id + "/", requireToken: true });
const createPurchaseRequest = (data) =>
  request({ method: "POST", url: endPointPurchase_requests, data: data, requireToken: true });
const updatePurchaseRequest = (id, data) =>
  request({ method: "PATCH", url: endPointPurchase_requests + id + "/", data: data, requireToken: true });
const submitPurchaseRequest = (id) =>
  request({ method: "POST", url: endPointPurchase_requests + id + "/submit/", requireToken: true });
const deletePurchaseRequest = (id) =>
  request({ method: "DELETE", url: endPointPurchase_requests + id + "/", requireToken: true });

const endPointPurchase_lines = "/purchase/lines/";
const endPointPurchase_vendors = "/purchase/vendors/";
const endPointPurchase_rates = "/purchase/rates/";
const endPointPurchase_orders = "/purchase/orders/";
const endPointPurchase_request_projects = "/purchase/request_projects/";

const getPurchaseRequestProjects = () =>
  request({ method: "GET", url: endPointPurchase_request_projects, requireToken: true });
const getPurchaseRemarks = (id) =>
  request({ method: "GET", url: endPointPurchase_requests + id + "/remarks/", requireToken: true });
const addPurchaseRemark = (id, data) =>
  request({ method: "POST", url: endPointPurchase_requests + id + "/remarks/", data: data, requireToken: true });
const getPurchaseLines = (params) =>
  request({ method: "GET", url: endPointPurchase_lines, data: { params: params }, requireToken: true });
const pricePurchaseLine = (id, data) =>
  request({ method: "POST", url: endPointPurchase_lines + id + "/price/", data: data, requireToken: true });
const approvePurchaseLines = (data) =>
  request({ method: "POST", url: endPointPurchase_lines + "approve/", data: data, requireToken: true });
const rejectPurchaseLine = (id, data) =>
  request({ method: "POST", url: endPointPurchase_lines + id + "/reject/", data: data, requireToken: true });
const getPurchaseOrders = (params) =>
  request({ method: "GET", url: endPointPurchase_orders, data: { params: params }, requireToken: true });
const getPurchaseVendors = (params) =>
  request({ method: "GET", url: endPointPurchase_vendors, data: { params: params }, requireToken: true });
const createPurchaseVendor = (data) =>
  request({ method: "POST", url: endPointPurchase_vendors, data: data, requireToken: true });
const updatePurchaseVendor = (id, data) =>
  request({ method: "PATCH", url: endPointPurchase_vendors + id + "/", data: data, requireToken: true });
const getPurchaseRates = (params) =>
  request({ method: "GET", url: endPointPurchase_rates, data: { params: params }, requireToken: true });
const savePurchaseRates = (data) =>
  request({ method: "POST", url: endPointPurchase_rates + "bulk/", data: data, requireToken: true });
const copyPurchaseRateGrade = (data) =>
  request({ method: "POST", url: endPointPurchase_rates + "copy_grade/", data: data, requireToken: true });


export {
  request,
  endPointExport_as,
  baseProject,
  baseProject_payment,
  baseSupplier_estimates,
  baseSupplier_estimatesWithQuery,
  postLogout,
  postUserLogin,
  getUsersProfile,
  getProfile,
  updateProfile,
  createUpdateUserProfile,
  deleteUsersProfile,
  forgetPassword,
  postCheck_validity,
  postReset_password,
  getCustomer,
  postChange_password,
  getProject,
  postProject,
  fetchPendingAllocations,
  allocateProjectTeam,
  fetchPaymentsDashboard,
  markPaymentCollected,
  createManualPaymentTask,
  deleteManualPaymentTask,
  editPaymentTask,
  searchProjects,
  fetchReportSiteMarking,
  fetchReport3DDiscussion,
  fetchReportQuotation,
  fetchReport2DMaterial,
  fetchReportHandoverPending,
  fetchReportCutlistPending,
  fetchReportCutlistDoneNoPlan,
  fetchReportFactoryProduction,
  fetchReportDispatchPending,
  fetchReportCarcass,
  fetchReportAccessories,
  fetchReportFinalFitting,
  fetchReportSiteMaskingPending,
  fetchReportPlanVsActual,
  fetchReportProjectBreakdown,
  fetchReportTimeline,
  getTask,
  postTask,
  getSubcontractor_type,
  postSubcontractor_type,
  getSubcontractor,
  postSubcontractor,
  getSubcontractor_estimate,
  postSubcontractor_estimate,
  getVendor_types,
  postVendor_types,
  getVendors,
  postVendors,
  getVendor_estimates,
  postVendor_estimates,
  getSideBar,
  getSignoff,
  postSignoff,
  getTask_history,
  postTask_history,
  getProject_signoff,
  postProject_signoff,
  getDrivem,
  postDrivem,
  getCategories,
  getSubCategories,
  getSupplier_estimate_pay_history,
  postSupplier_estimate_pay_history,
  getPayments,
  postPayments,
  getProject_payment,
  postProject_payment,
  getQuestion,
  postQuestion,
  getQueries,
  postQueries,
  getProject_queries,
  postProject_queries,
  getChecklist,
  postChecklist,
  getLabour_payment_report,
  getCashbook_report,
  getProject_orders,
  postProject_orders,
  getPointOrder_items,
  postOrder_items,
  getOrders,
  postOrders,
  getOrder_items_history,
  postOrder_items_history,
  getSupplier_quotation,
  postSupplier_quotation,
  postOrder_item_upload,
  getTeamMembers,
  adminResetPassword,
  getFactoryProductionMeta,
  getStageCapacities,
  upsertStageCapacity,
  updateStageCapacity,
  getProductionEntries,
  createProductionEntry,
  updatePlan,
  deletePlan,
  updateProductionEntry,
  deleteProductionEntry,
  searchFactoryProjects,
  buildFactoryExportUrl,
  getFactoryDailyTotals,
  markProductionEntryDone,
  getPurchaseOptions,
  searchPurchaseProjects,
  getPurchaseRequests,
  getPurchaseRequest,
  createPurchaseRequest,
  updatePurchaseRequest,
  submitPurchaseRequest,
  deletePurchaseRequest,
  getPurchaseRequestProjects,
  getPurchaseRemarks,
  addPurchaseRemark,
  getPurchaseLines,
  pricePurchaseLine,
  approvePurchaseLines,
  rejectPurchaseLine,
  getPurchaseOrders,
  getPurchaseVendors,
  createPurchaseVendor,
  updatePurchaseVendor,
  getPurchaseRates,
  savePurchaseRates,
  copyPurchaseRateGrade,
};


// ---------------------------------------------------------------------------
// F6 - Civil Engineer Reassignment
// ---------------------------------------------------------------------------
export async function fetchReassignmentOptions(projectId) {
  const url = isDevelopment
    ? `${baseURL}/project/${projectId}/reassignment_options/`
    : `${host}/api/${version}/project/${projectId}/reassignment_options/`;
  const response = await axios.get(url, {
    headers: { Authorization: localStorage.getItem("token") },
  });
  return response.data;
}

export async function reassignCivilEngineer(projectId, fromUserId, toUserId) {
  const url = isDevelopment
    ? `${baseURL}/project/${projectId}/reassign_civil_engineer/`
    : `${host}/api/${version}/project/${projectId}/reassign_civil_engineer/`;
  const response = await axios.post(
    url,
    { from_user_id: fromUserId, to_user_id: toUserId },
    {
      headers: { Authorization: localStorage.getItem("token") },
    }
  );
  return response.data;
}

// ---------------------------------------------------------------------------
// Purchase - receipts + invoice tally
// ---------------------------------------------------------------------------
const purchaseUrl = (path) =>
  isDevelopment ? `${baseURL}/purchase/${path}` : `${host}/api/${version}/purchase/${path}`;

const purchaseError = (e) => {
  const d = e && e.response && e.response.data;
  const msg = (d && (d.detail || (typeof d === "string" ? d : ""))) || (e && e.message) || "Request failed.";
  return new Error(msg);
};

export const getPurchaseTally = (params) =>
  request({ method: "GET", url: "/purchase/tally/", data: { params: params }, requireToken: true });
export const receivePurchaseLine = (id, data) =>
  request({ method: "POST", url: "/purchase/lines/" + id + "/receive/", data: data, requireToken: true });
export const closeShortPurchaseLine = (id, data) =>
  request({ method: "POST", url: "/purchase/lines/" + id + "/close_short/", data: data, requireToken: true });
export const deletePurchaseReceipt = (id) =>
  request({ method: "DELETE", url: "/purchase/receipts/" + id + "/", requireToken: true });
export const deletePurchaseInvoice = (id) =>
  request({ method: "DELETE", url: "/purchase/invoices/" + id + "/", requireToken: true });

export async function addPurchaseInvoice(poId, formData) {
  try {
    const response = await axios.post(purchaseUrl("orders/" + poId + "/invoices/"), formData, {
      headers: { Authorization: localStorage.getItem("token") },
    });
    return response.data;
  } catch (e) {
    throw purchaseError(e);
  }
}

export async function downloadPurchaseInvoice(invoiceId, filename) {
  try {
    const response = await axios.get(purchaseUrl("invoices/" + invoiceId + "/file/"), {
      headers: { Authorization: localStorage.getItem("token") },
      responseType: "blob",
    });
    const blobUrl = window.URL.createObjectURL(response.data);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename || "invoice";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 2000);
  } catch (e) {
    throw purchaseError(e);
  }
}

export async function downloadPurchaseOrderPdf(poId, poNumber) {
  try {
    const response = await axios.get(purchaseUrl("orders/" + poId + "/pdf/"), {
      headers: { Authorization: localStorage.getItem("token") },
      responseType: "blob",
    });
    const blobUrl = window.URL.createObjectURL(response.data);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = (poNumber || "PO-" + poId) + ".pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 2000);
  } catch (e) {
    throw purchaseError(e);
  }
}
